module.exports = __webpack_public_path__ + "img/siren.8691f8e3.svg";